// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-dialog .el-radio-button {\n  display: block;\n  margin: 5px 0;\n}\n.phone-dialog .el-radio-button__inner {\n  border-left: 1px solid #DCDFE6;\n}\n.phone-dialog .el-button--small {\n  display: block;\n  width: 100%;\n}\n.phone-dialog .el-button + .el-button {\n  margin-left: unset;\n}\n.el-radio-button .el-radio-button__inner {\n  border-left: 1px solid #dcdfe6;\n}", ""]);
// Exports
module.exports = exports;
